module.exports = __webpack_public_path__ + "fonts/fontello.d9c7d91.woff";